module.exports = __webpack_public_path__ + "img/image1.9f70aa8b.png";